import React from "react";
import classNames from "classnames";
import * as S from "./styles";

export default ({ className, children, ...props }) => (
  <S.Button onMouseDown={e => e.preventDefault()} className={classNames("tabbable", className)} {...props}>
    {children}
  </S.Button>
);
